import React, { useState } from 'react';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import AddCombo from './combo/AddCombo';
import ComboList from './combo/ComboList';
import { Package, Plus, List } from 'lucide-react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ComboManagement = () => {
  const [activeTab, setActiveTab] = useState('list');

  // Handle successful combo addition
  const handleComboAdded = () => {
    // Switch to list tab after successful addition
    setActiveTab('list');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Global Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName="relative flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer"
      />
      
      <AdminNavbar />
      <div className="flex">
        <AdminSidebar />
        <main className="flex-1 p-6">
          {/* Page Header */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <Package className="h-8 w-8 text-indigo-600 mr-3" />
              <h1 className="text-2xl font-bold text-gray-800">Combo Management</h1>
            </div>
            
            {/* Quick Action Button */}
            <button
              onClick={() => setActiveTab(activeTab === 'add' ? 'list' : 'add')}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {activeTab === 'add' ? (
                <>
                  <List className="h-4 w-4 mr-2" />
                  View Combos
                </>
              ) : (
                <>
                  <Plus className="h-4 w-4 mr-2" />
                  Add New Combo
                </>
              )}
            </button>
          </div>
          
          <div className="bg-white rounded-lg shadow border border-gray-200">
            {/* Tab Navigation */}
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex space-x-8 px-6">
                <button
                  onClick={() => setActiveTab('list')}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === 'list'
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <div className="flex items-center">
                    <List className="h-5 w-5 mr-2" />
                    Combo List
                  </div>
                </button>
                <button
                  onClick={() => setActiveTab('add')}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === 'add'
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <div className="flex items-center">
                    <Plus className="h-5 w-5 mr-2" />
                    Add New Combo
                  </div>
                </button>
              </nav>
            </div>

            {/* Tab Content */}
            <div className="p-6">
              {activeTab === 'list' && (
                <ComboList key="combo-list" />
              )}
              {activeTab === 'add' && (
                <AddCombo 
                  key="add-combo"
                  onSave={handleComboAdded}
                />
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ComboManagement;